import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-discuss-forum',
  templateUrl: './discuss-forum.component.html',
  styleUrls: ['./discuss-forum.component.css']
})
export class DiscussForumComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
